import { Paths, PathValue } from "@mctypes/global.types";
import { Button, Flex, Paper, Radio, Stack, Title, Box } from "@mantine/core";
import { HSpace, McInputNew, McTextAreaNew } from "../../../../../../../components";
import { IGKLekkasjeskanningAvHepaResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
import { beregnetMaksimalLekkasjeverdi } from "../../gkGlobalUtils";
const LekkasjeskanningAvHepaLAFTak: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKLekkasjeskanningAvHepaResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const newFilter = {
      filterNr: "",
      maaleresultaterOppstroems: null,
      godkjent: null,
      maaleresultaterNedstroems: null,
      maksimalLekkasjeverdi: null,
      beskrivelseAvLekkasjeLokasjon: "",
    };
    const updatedMaaleresultater = [...data.inndata.maaleresultater, newFilter];
    onUpdateEditData("testResultater.lekkasjeskanningAvHepaLAFTak.inndata.maaleresultater", updatedMaaleresultater);
    return updatedMaaleresultater;
  };
  const removeLastRow = () => {
    const updatedMaaleresultater = [...data.inndata.maaleresultater];
    if (updatedMaaleresultater.length > 0) {
      updatedMaaleresultater.pop(); // Remove the last element
      onUpdateEditData("testResultater.lekkasjeskanningAvHepaLAFTak.inndata.maaleresultater", updatedMaaleresultater);
    }
  };
  const updateMaaleresultater = (resultat: string | number | boolean, i: number, parameter: string) => {
    const maaleresultater = [...data.inndata.maaleresultater];
    maaleresultater[i][parameter] = resultat;
    maaleresultater[i].maksimalLekkasjeverdi = beregnetMaksimalLekkasjeverdi(
      maaleresultater[i].maaleresultaterOppstroems,
    );
    onUpdateEditData("testResultater.lekkasjeskanningAvHepaLAFTak.inndata.maaleresultater", maaleresultater);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Lekkasjeskanning av HEPA-filter
        </Title>
        <Stack gap={0}>
          <b>Hvor mange målinger skal utføres? &#40;-&#41;:</b>
          <Flex>
            <Button color="green" onClick={addNewRow}>
              Legg til rad
            </Button>
            <HSpace />
            <Button variant="danger-filled" onClick={removeLastRow}>
              Fjern siste rad
            </Button>
          </Flex>
        </Stack>
        {Number(data.inndata.maaleresultater.length) > 0 && (
          <Flex direction="column" mt="lg">
            <b>Fyll inn måleresultater:</b>
            <table>
              <thead>
                <tr>
                  <th>Filternummer &#40;-&#41;</th>
                  <th>
                    Måleresultat oppstrøms &#40;mg/m<sup>3</sup>&#41;
                  </th>
                  <th style={{ display: "flex", justifyContent: "center" }}>Verdi høyere enn 0,01 &#40;%&#41;?</th>
                  <th>Belastning etter test &#40;%&#41;</th>
                  {data.inndata.maaleresultater.some((resultat) => resultat.godkjent === true) && (
                    <>
                      <th>Resultat nedstrøms &#40;%&#41;</th>
                      <th>Lekkasjelokasjon</th>
                    </>
                  )}
                </tr>
              </thead>
              {data.inndata.maaleresultater.map((filter, i) => (
                <tbody key={i}>
                  <tr>
                    <td>
                      <McInputNew
                        value={filter.filterNr}
                        type="text"
                        onChange={(e) => updateMaaleresultater(e.target.value, i, "filterNr")}
                        placeholder="Filternummer"
                      />
                    </td>
                    <td>
                      <McInputNew
                        value={filter.maaleresultaterOppstroems}
                        normalizeNumbers={true}
                        type="text"
                        onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "maaleresultaterOppstroems")}
                        placeholder="Måleresultat oppstrøms"
                      />
                    </td>
                    <td>
                      <Flex
                        direction="row"
                        justify="space-around"
                        align="center"
                        style={{ backgroundColor: "#ebecec", borderRadius: "6px", height: "2.2rem" }}
                      >
                        <Radio
                          checked={filter.godkjent === true}
                          onChange={() => updateMaaleresultater(true, i, "godkjent")}
                          label="Ja"
                        />
                        <Radio
                          checked={filter.godkjent === false}
                          onChange={() => updateMaaleresultater(false, i, "godkjent")}
                          label="Nei"
                        />
                      </Flex>
                    </td>
                    <td>
                      <McInputNew
                        value={filter.konsentrasjonFoerFilterEtterTest}
                        normalizeNumbers={true}
                        type="text"
                        onBlur={(e) =>
                          updateMaaleresultater(Number(e.target.value), i, "konsentrasjonFoerFilterEtterTest")
                        }
                      />
                    </td>
                    {filter.godkjent === true && (
                      <>
                        <td>
                          <McInputNew
                            value={filter.maaleresultaterNedstroems}
                            normalizeNumbers={true}
                            type="text"
                            onBlur={(e) =>
                              updateMaaleresultater(Number(e.target.value), i, "maaleresultaterNedstroems")
                            }
                            placeholder="Måleresultat nedstrøms"
                          />
                        </td>
                        <td>
                          <McInputNew
                            value={filter.beskrivelseAvLekkasjeLokasjon}
                            type="text"
                            onChange={(e) => updateMaaleresultater(e.target.value, i, "beskrivelseAvLekkasjeLokasjon")}
                            placeholder="Beskrivelse av lekkasjelokasjon"
                          />
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              ))}
            </table>
          </Flex>
        )}
        {Number(data.inndata.maaleresultater.length) > 0 && (
          <Box mt="lg">
            <ReportDocxImageContainer docxImageTag="lekkasjeskanningAvHepaLAFTak" title="Målepunkter" />
            <div style={{ width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.kommentar}
                onChange={(e) =>
                  onUpdateEditData("testResultater.lekkasjeskanningAvHepaLAFTak.inndata.kommentar", e.target.value)
                }
              />
            </div>
          </Box>
        )}
      </Stack>
    </Paper>
  );
};
export default LekkasjeskanningAvHepaLAFTak;
